<template>
  <v-container fluid class="superTable pa-0">
    <v-row no-gutters>
      <v-col sm="4">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :placeholder="$t('actions.search')"
          outlined
          clearable
          class="superTable__search"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col sm="12">
        <v-data-table
          v-model="selectedItems"
          :show-select="false"
          :headers="headers"
          :items="users"
          :search="search"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          hide-default-footer
          item-key="id"
          class="superTable__table"
          style="width: 100%; table-layout: fixed; min-width: 1200px"
        >
          <template v-slot:top v-if="permissions.delete">
            <div
              :class="[
                'superTable__bulkActions',
                'py-2',
                areItemsSelected ? 'show' : 'hide',
              ]"
            >
              <v-divider></v-divider>
              <div class="py-3">
                <span
                  v-if="permissions.delete"
                  class="caption mx-4 cursor-pointer hover-7-inverted"
                  @click="bulkDelete()"
                  ><v-icon size="22" class="mr-2">mdi-delete</v-icon
                  >{{ deleteTitle }}</span
                >
              </div>
              <v-divider></v-divider>
            </div>
          </template>

          <template v-slot:header.data-table-select="{ on, props }">
            <v-simple-checkbox
              class="superTable__table__item__checkbox"
              color="primary"
              v-bind="props"
              v-on="on"
            ></v-simple-checkbox>
          </template>

          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox
              class="superTable__table__item__checkbox"
              color="primary"
              :value="isSelected"
              @input="select($event)"
            ></v-simple-checkbox>
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon
              size="12"
              :color="(item.status == 4) ? 'error' : (item.status == 1)? 'grey lighten-2' : 'success' "
              >mdi-circle</v-icon
            >
          </template>

          <template v-slot:item.hasNoDebt="{ item }">
            <v-icon
              size="12"
              :color="item.hasNoDebt ? 'success' : 'error' "
              >mdi-circle</v-icon
            >
          </template>

          <template
            v-slot:item.action="{ item }"
            v-if="permissions.update || permissions.delete"
          >
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" class="superTable__table__item__action"
                  >mdi-dots-vertical</v-icon
                >
              </template>
              <v-list class="pa-0">
                <v-list-item
                  v-if="item.status == 1"
                  @click="editTitle(item.id)"
                >
                  <v-list-item-title>
                    <v-icon>mdi-pencil</v-icon> {{ $t("actions.edit") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="(item.status == 1 && itemValid(item))"
                  @click="generateTitle(item.id)"
                >
                  <v-list-item-title>
                    <v-icon>mdi-file</v-icon> Generar PDF
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.status == 2"
                  @click="downloadTitleStamped(item.id)"
                >
                  <v-list-item-title>
                    <v-icon>mdi-pencil</v-icon> Descargar título sellado
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.status == 1 || item.status == 2"
                  @click="downloadTitleNotStamped(item.id)"
                >
                  <v-list-item-title v-if="item.status == 1">
                    <v-icon>mdi-pencil</v-icon> Descargar previsualización
                  </v-list-item-title>
                  <v-list-item-title v-if="item.status == 2">
                    <v-icon>mdi-pencil</v-icon> Descargar título sin sellos
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.status != 4"
                  @click="cancelTitle(item.id)"
                >
                  <v-list-item-title>
                    <v-icon>mdi-delete</v-icon> Anular
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="item.status == 4"
                  @click="restoreTitle(item.id)"
                >
                  <v-list-item-title>
                    <v-icon>mdi-delete</v-icon> Volver a pendiente
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
        <v-divider class="mt-4 mb-8"></v-divider>
      </v-col>
    </v-row>
    <v-row no-gutters align="center">
      <v-col sm="3">
        <span class="caption d-inline-block">{{
          itemsCount.startItem +
          " - " +
          itemsCount.endItem +
          " de " +
          itemsCount.totalItems
        }}</span>
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPageAvailable"
          :placeholder="itemsPerPage.toString()"
          outlined
          class="superTable__paginationSelect d-inline-block ml-4"
        ></v-select>
      </v-col>
      <v-col sm="6" class="text-center">
        <v-pagination
          v-model="page"
          :length="pageCount"
          class="superTable__pagination"
        ></v-pagination>
      </v-col>
      <v-col sm="3" align="right">
        <v-text-field
          v-model="page"
          max="pageCount"
          outlined
          class="superTable__paginationInput d-inline-block mr-4"
        ></v-text-field>
        <span class="caption d-inline-block">{{ $t("actions.goToPage") }}</span>
      </v-col>
    </v-row>
  </v-container>
</template>
 
 <style lang="sass" scoped>
.v-expansion-panels
    .v-expansion-panel-content
        padding-left: 10px
        padding-bottom: 0px
        padding-right: 16px
</style>
 
 <script>
import Constants from '@/plugins/constants';

export default {
  name: 'SuperTable',
  props: {
    users: Array,
    headers: Array,
    clearSelected: String,
    deleteTitle: String,
    permissions: { update: false, delete: false },
  },
  data() {
    return {
      selectedItems: [],
      search: '',
      page: 1,
      itemsPerPage: 20,
      itemsPerPageAvailable: [20, 50, 100, 200],
      markedUsers: [],
    };
  },
  methods: {
    itemValid(item) {
      return item.id != null && item.studentRecordId != null && item.studentName != null && item.registry != null;
    },
    bulkDelete() {
      const canDelete = !this.selectedItems.find((selected) => {
        if (selected.subjects_count > 0) {
          return selected;
        }
      });

      if (canDelete) {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.departments.table.bulk_delete'),
          actionPrimary: {
            text: this.$t('modules.departments.table.delete'),
            callback: () => {
              this.$emit('bulk-delete', this.selectedItems);
            },
          },
          actionSecondary: {
            text: this.$t('modules.departments.table.cancel'),
            callback() {},
          },
          icon: { color: 'warning', name: 'mdi-alert-outline' },
          color: 'primary',
        });
      } else {
        this.$store.dispatch('commons/openPopUp', {
          title: this.$t('modules.departments.table.bulk_delete_error'),
          actionPrimary: {
            text: this.$t('modules.departments.table.accept'),
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert-outline' },
          color: 'primary',
        });
      }
    },

    getAvatar(id) {
      return `${Constants.URL_DATA_SERVER}/users/${id}/avatar`;
    },
    editTitle(id) {
      this.$emit('updateTitle', id);
    },
    generateTitle(id) {
      this.$emit('generateStudentTitle', id);
    },
    downloadTitleStamped(id){
      this.$emit('downloadTitleStamped', id);
    },
    downloadTitleNotStamped(id){
      this.$emit('downloadTitleNotStamped', id);
    },
    cancelTitle(id){
      this.$emit('cancelTitle', id)
    },
    restoreTitle(id){
      this.$emit('restoreTitle', id)
    },
    deleteItem(id) {
      const itemToDelete = this.users.find((item) => {
        if (item.id === id) {
          return item;
        }
      });

      if (itemToDelete.subjects_count === 0) {
        this.$emit('deleteUser', id);
      }
    },
  },
  watch:{
             'page': function (val) {
                 if(val > this.pageCount)
                     this.page = this.pageCount;
                 if(val <= 1)
                     this.page = 1;
             },
             'clearSelected': function () {
                 this.selectedItems = []
             }
         },
  computed: {
    areItemsSelected() {
      return !!this.selectedItems.length;
    },
    pageCount() {
      let counter = this.users.length / this.itemsPerPage;

      if (counter < 1) {
        counter = 1;
      }

      return Math.ceil(counter);
    },
    itemsCount() {
      const counter = {
        totalItems: this.users.length,
        startItem: this.page * this.itemsPerPage - this.itemsPerPage + 1,
        endItem: this.page * this.itemsPerPage,
      };

      if (counter.endItem > this.users.length) {
        counter.endItem = this.users.length;
      }

      return counter;
    },
  },
};
</script>